export default __webpack_public_path__ + "static/med-4a3498e21263e3e832c254ade0fca886.jpg";